module.exports = (__parcel__import__("./" + "Doppio.bbc51261.js")).then(() => parcelRequire('jTOzh'));